import { render, staticRenderFns } from "./rectangleLayerDrawer.vue?vue&type=template&id=3b4ee5c6&"
import script from "./rectangleLayerDrawer.vue?vue&type=script&lang=ts&"
export * from "./rectangleLayerDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports